<template>
  <el-table
    :data="tableData"
    stripe
    style="width: 100%"
  >
    <el-table-column
      sortable
      prop="customer"
      :label="$t('cliente')"
    ></el-table-column>
    <el-table-column
      sortable
      prop="name"
      :label="$t('nome')"
    ></el-table-column>
    <el-table-column prop="type" :label="$t('tipo')" sortable>
      <template slot-scope="scope">{{
        scope.row.type === "1"
          ? $t("interno")
          : scope.row.type === "2"
          ? $t("cliente")
          : scope.row.type === "3"
          ? $t("parceiro")
          : scope.row.type === "4"
          ? $t("motorista")
          : $t("filial")
      }}</template>
    </el-table-column>
    <el-table-column
      sortable
      prop="username"
      :label="$t('login')"
    ></el-table-column>
    <el-table-column
      sortable
      prop="mail"
      :label="$t('email')"
    ></el-table-column>
    <el-table-column prop="active" :label="$t('ativo')" sortable>
      <template slot-scope="scope">{{
        scope.row.active ? $t("sim") : $t("nao")
      }}</template>
    </el-table-column>
    <el-table-column width="165">
      <template slot-scope="scope">
        <el-button
          type="info"
          icon="el-icon-edit"
          @click="edit(scope.row.id)"
          circle
        ></el-button>
        <el-button
          type="danger"
          icon="el-icon-delete"
          @click="remove(scope.row.id, scope.row.name)"
          circle
        ></el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: "ShippingSequenceTable",
  data() {
    return {
      tableData: [],
    }
  },
  methods: {
    edit(id) {
      this.$router.replace({
        name: "shipping.edit",
        params: { id: id },
      });
    },
    remove(id, name) {
      const vm = this;
      this.$confirm(i18n.t("confirmar-eliminacao-transportadora", { id: name }), i18n.tc("aviso"), {
        confirmButtonText: "OK",
        cancelButtonText: i18n.tc("cancelar"),
        type: i18n.tc("aviso"),
        center: true,
      }).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        UserService.delete(id)
          .then((response) => {
            setTimeout(() => {
                const index = vm.tableData.findIndex((dt) => dt.id == id);
                vm.tableData.splice(index, 1);
            }, 300);
            this.$message({
                type: "success",
                message: i18n.tc("usuario-eliminado-sucesso"),
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
  },
}
</script>